/*
Locks

  --mount <string::enum> | ['Horizontal', 'Vertical']
  --setBack <float> | inches
  --throwDistance <float> | inches
  --materialThickness <float> | inches | default: 3/4"

*/
import hardwareHeaders from '@/modules/standardItems/schemas/hardware/headers'

export default [
  ...hardwareHeaders,
  {
    text: 'Mount',
    value: 'mount',
    sortable: true,
    sort: 'string'
  },
  {
    text: 'Set Back (in)',
    value: 'setBack',
    sortable: true,
    sort: 'number',
    render: 'fraction',
    unit: 'inches'
  },
  {
    text: 'Throw Distance (in)',
    value: 'throwDistance',
    sortable: true,
    sort: 'number',
    render: 'fraction',
    unit: 'inches'
  },
  {
    text: 'Material Thickness',
    value: 'materialThickness',
    sortable: true,
    sort: 'number',
    unit: 'inches'
  }
]
